import React from 'react';
import {HeartHandshake} from "lucide-react";
import Image1 from "../images/Images1.png";
import Image2 from "../images/Images2.png";
import Image3 from "../images/Images3.png";
import Image4 from "../images/Images4.png";
import Image5 from "../images/Images5.png";
import Image6 from "../images/Images6.png";

const services = [
    {
        title: "Therapeutic Massage",
        image: Image1
    },
    {
        title: "Reiki Healing Session",
        image: Image2
    },
    {
        title: "Lymphatic Massage",
        image: Image3
    },
    {
        title: "Sound Healing Ceremony",
        image: Image4
    },
    {
        title: "Cupping & Hot Stone Therapy",
        image: Image5
    },
    {
        title: "Prenatal Wellness Massage",
        image: Image6
    }
];
const additionalServices = [
    "Therapeutic Massage",
    "Reiki Healing",
    "Sound Healing",
    "Lymphatic Massage",
    "Stress Relief Therapy",
    "Prenatal Massage",
    "Hot Stone Therapy",
    "Cupping Therapy",
    "Breathwork Sessions",
    "Guided Meditation",
    "Sound Baths",
    "Corporate Wellness",
    "Children's Wellness Workshops",
    "Spa & Wellness Events",
    "End-of-Life Doula Support",
];

export const Menu = () => {
    return (
        <section className='services-section' id='services'>
            <div className='section-content'>
                <div className='services-header'>
                    <h2 className='section-title'>Our Wellness Services</h2>
                    <p className='services-subtitle'>Discover personalized treatments designed to restore balance, promote relaxation, and support your well-being.</p>
                </div>
                <div className='services-list-panel'>
                    <ul className='services-list-grid'>
                        {additionalServices.map((service) => (
                            <li key={service} className='services-list-item'>
                                <span className='services-list-badge' aria-hidden='true'>
                                    <HeartHandshake/>
                                </span>
                                <span>{service}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='services-grid'>
                    {services.map((service) => (
                        <article
                            key={service.title}
                            className='service-card'
                            aria-label={service.title}
                        >
                            <img
                                src={service.image}
                                alt={service.title}
                                className='service-card-image'
                                loading='lazy'
                            />
                            <div className='service-card-overlay'/>
                        </article>
                    ))}
                </div>

                <div className='wellness-pricing-panel'>
                    <h3 className='wellness-pricing-title'>Our Wellness Prices</h3>
                    <div className='wellness-offer'>
                        <h4 className='wellness-pricing-subtitle'>Intuitive Therapeutic Massage</h4>
                        <p className='wellness-pricing-text'>
                            <strong>Description:</strong> A restorative physical journey tailored to your body's unique needs. By intuitively weaving together specialized techniques, this session melts away physical tension, clears blockages, and restores your natural, vibrant flow.
                        </p>
                        <p className='wellness-pricing-text'>
                            <strong>Includes:</strong> Your customized session may include a blend of deep tissue, lymphatic drainage, myofascial release, cupping, hot stones, prenatal care, reflexology, and aromatherapy.
                        </p>
                        <p className='wellness-pricing-text wellness-pricing-rate'>
                            <strong>Pricing Structure:</strong> 60 minutes - $175 | 90 minutes - $245 | 120 minutes - $315
                        </p>
                    </div>

                    <div className='wellness-offer'>
                        <h4 className='wellness-pricing-subtitle'>Usui Reiki-Infused Massage</h4>
                        <p className='wellness-pricing-text'>
                            <strong>Description:</strong> A soul-centered session that seamlessly blends traditional Usui Reiki energy healing with intuitive therapeutic touch. These holistic therapies are designed not only to relax the physical body but also to clear energetic blockages and promote deep emotional release. As your nervous system finds harmony, you will gain greater clarity, awareness, and a profound connection to your inner being.
                        </p>
                        <p className='wellness-pricing-text'>
                        <strong>Includes:</strong> Your customized session may include a blend of therapeutic massage, Reiki energy healing, deep tissue massage, lymphatic drainage, myofascial release, cupping, hot stone therapy, prenatal care, reflexology, aromatherapy, and intuitive healing techniques.
                        </p>
                        <p className='wellness-pricing-text wellness-pricing-rate'>
                            <strong>Pricing Structure:</strong> 60 minutes - $200 | 90 minutes - $275 | 120 minutes - $340
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}
